<p>profile works!</p>
 <!-- <div class="row">
      <div class="col-12 col-md-12 p-0 pointer" (click)="goToPage('auth')">
        <img src="../../../assets/img/PDR-Brand-Survey-Cover.jpg" class="img-fluid" alt="...">
      </div>
    </div> -->
